module.exports = __webpack_public_path__ + "static/media/editor_ho.3f60f928.png";